/** Clipboard writes reject in restrictive contexts — never let that crash the tree. */
export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};
